import $ from 'jquery';
import 'slick-carousel';

$(() => {
    const newsSlider = $('.js-blog-slider');

    newsSlider.each((i, el) => {
        $(el).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: false,
            arrows: true,
            appendArrows: el.parentNode.querySelector('.js-blog-slider-arrows'),
            infinite: false,
            prevArrow: el.parentNode.querySelector('.js-blog-slider-prev'),
            nextArrow: el.parentNode.querySelector('.js-blog-slider-next'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        variableWidth: true,
                        centerMode: true,
                    }
                },
            ]
        });
    });
})


// WEBPACK FOOTER //
// ./themes/maisondubillard/_dev/js/modules/prestablog.js